export default __webpack_public_path__ + "static/media/q1_step2_4.1b8aaf57.png";